import {ConVendorName, ConVendorNameWm, ConVendorNameMap,ConVendorName2} from '@/config'
import {formatDate} from '@/utils'
const mixins = {
  data () {
    return {
      ConVendorName,
      ConVendorName2,
      ConVendorNameWm,
      ConVendorNameMap,
      a: 12
    }
  },
  filters: {
    toFixed2 (num) {
      return (num / 100).toFixed(2)
    },
    timeToYYYY (time) {
      return formatDate(time, 'YYYY-MM-DD hh:mm:ss')
    }
  },
  methods: {
    getTime () {
      return new Date()
    }
  }
}

export default mixins



// WEBPACK FOOTER //
// ./src/mixins/index.js